/* istanbul ignore file */
import { Box, CircularProgress } from '@mui/material'

export default () => (
  <Box
    className="center-all"
    data-testid="aroya-route-loading"
    sx={{
      overflow: 'hidden',
    }}
  >
    <CircularProgress color="primary" />
  </Box>
)
